export var EChild = /*#__PURE__*/function (EChild) {
  EChild["Header"] = "Header";
  EChild["Content"] = "Content";
  EChild["Buttons"] = "Buttons";
  return EChild;
}({});
export var COPYRIGHT = 'платёжный виджет © {{year}}';